









import Vue from "vue";
import Component from "vue-class-component";
import { users } from "../api/users/users";
@Component({
  name: "ChangePassword"
})
export default class ChangePassword extends Vue {
  public newpass: string = "";
  public async change() {
    await users.changePassword(
      this.$store.getters.getToken,
      this.newpass,
      this.$store.getters.getHost
    );
    this.$store.dispatch("updateCurrentComponent", "Logout");
    this.$router.replace({
      name: "load"
    });
  }
}
